import { render, staticRenderFns } from "./SalesReturns.vue?vue&type=template&id=797e1d2c&scoped=true&"
import script from "./SalesReturns.vue?vue&type=script&lang=js&"
export * from "./SalesReturns.vue?vue&type=script&lang=js&"
import style0 from "./SalesReturns.vue?vue&type=style&index=0&id=797e1d2c&prod&lang=scss&"
import style1 from "./SalesReturns.vue?vue&type=style&index=1&id=797e1d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e1d2c",
  null
  
)

export default component.exports